import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import { MainLinkButton } from "../../styled/buttons/MainLinkButton";
import { BundlePercentageBlueIcon } from "../../../modules/Icons";
import { CheckmarkIcon } from '../../../modules/Icons';

import { BannerCardProps } from "../../../types/components/bundles/banners/BannerCard";

export const bannerCardContainer = "hidden lg:flex bg-[#252A2D] bg-opacity-70 backdrop-blur-md rounded-[5px] xl:w-[437px] gap-5 !px-[6px] !py-[6px] h-min"
export const savingsTagContainer = "absolute inset-0 flex items-center justify-center"
export const savingsTagText = "text-black uppercase bg-[#FF9D00] bg-opacity-95 rounded-[5px] font-bold p-2 w-fit gap-[10px] text-[14px] xl:text-[16px] flex items-center"


export const textContaner = "flex flex-col justify-center gap-4"
export const textStyle = "text-[12px] xl:text-[14px] flex gap-2 items-center"
export const buttonStyle = "!w-[132px] !h-[40px] !text-[14px] gap-2 !capitalize"

import { LIBRARY_IDS } from '../../../constants/api';
const { LIBRARY_ID_2D } = LIBRARY_IDS;

export const BannerCard: React.FC<BannerCardProps> = ({
  bundle,
  backgroundUrl = '/img/freevfx.png',
}) => {
  if (!bundle) return;

  const router = useRouter();

  const [bannerBackgoundStyles, setBannerBackgroundStyles] = useState({});

  useEffect(() => {
    setBannerBackgroundStyles({
      backgroundImage: `url(${backgroundUrl})`
    });
  }, [backgroundUrl]);

  const buyBundleHandler = () => {
    router.push(`/${bundle.library_id === LIBRARY_ID_2D ? 'products' : '3d'}/bundles/${bundle.slug}`);
  };

  return (
    <div cy-test-id="owned-bundle-banner-card" className={bannerCardContainer}>
      <div className="relative min-w-[168px] h-[122px] xl:min-w-[182px] xl:min-h-[136px] bg-cover" style={bannerBackgoundStyles} />
      <div className={textContaner}>
        <div className={textStyle}><CheckmarkIcon />Bundle Owned</div>
        <MainLinkButton className={buttonStyle} onClick={buyBundleHandler} testId="action-button">
          <BundlePercentageBlueIcon />
          View Bundle
        </MainLinkButton>
      </div>
    </div>
  )
}

export default BannerCard;
